<template>
    <span>
        <b-button style="padding: 0px">
            <b-button @click="launch()">{{data_action.name}}<span v-if="nb > 0"> ({{ nb }} ligne{{nb > 1 ? 's' : ''}})</span></b-button>
            <b-button v-if="visible_column.length > 0" v-b-toggle="'action-'+ id"><i class="fas fa-cogs"> </i></b-button>
            <b-button v-if="test" @click="launch(1)">Test sur 1 ligne</b-button>
            <b-button v-if="test" @click="launch(10)">Test sur 10 lignes</b-button>
        </b-button>

        <b-collapse :id="'action-'+ id" :visible="data_action.default_view_parameters && visible">
            <br />
            <b-card>
                <c_treatment_params :type_save="action.params_save" :columns="columns" ref="actions" :dashboard="false" :only_visible="true"></c_treatment_params>
            </b-card>
        </b-collapse>
    </span>
</template>

<script>
	import * as json2csv from "json2csv";
	import uniqueId from "lodash.uniqueid";

    import c_treatment_params from "../params.vue"
    import treatments from "../../services/treatments.js";

    var clone = require("clone");

    export default {
        name: 'action',
		components: {
            c_treatment_params
        },
        props: {
            index: {},
            action: {
                default: () => {}
            },
            source_data: {
                default: null
            },
            idx: {
                default: null
            },
            nb: {
                default: 0
            },
            columns: {
                default: () => []
            },
            visible: {
                default: true
            },
            test: {
                default: false
            },
            idx_action: {
                default: 0
            }
        },
        data: function () {
            return {
                id: uniqueId(""),
                params: {},
                visible_column: [],
                treatment_params: {},
                data_action: {}
            };
        },
        watch: {
            action: {
				deep: true,
				async handler(value, oldValue) {
                    this.data_action = value;
                }
            }
        },
        methods: {
            async update_param(key, value)
            {
                console.log("update_param")
                this.$refs.actions.update(key, value)
            },
            async update_action(action)
            {
                this.data_action = action;
                console.log("update_action")
                console.log(clone(this.data_action))
                if (this.data_action.treatment_params_arr)
                {
                    for (var i = 0; i < this.data_action.treatment_params_arr.length; i++)
                    {
                        this.params[this.data_action.treatment_params_arr[i].name] = this.data_action.treatment_params_arr[i];
                        if (this.data_action.treatment_params_arr[i].visible)
                            this.visible_column.push(this.data_action.treatment_params_arr[i].name);
                    }
                }
                if (this.visible_column)
                    await this.$refs.actions.set(this.data_action.treatment_params_arr || [], this.data_action.treatment_params || {}, this.data_action.treatment_params_arr || []);
            },
            update_cell(index, column, data)
            {
                this.$emit("update_cell", index, column, data);
            },
            change_treatment_params()
            {
                this.treatment_params = this.$refs.actions.get_obj();
            },
            async launch(nb = 0)
            {
                var data = this.source_data(this.idx);

                if (nb)
                    data = data.slice(0, nb);

                var csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
                });
                
                csv = new Blob([csv], {
					type: "text/plain",
                });
                
                //console.log(this.action)

                var treatment_params = this.$refs.actions.get_obj();

                var res = await treatments
				.create(
					this.data_action.project_id,
					null,
					csv,
					"data.csv",
					"",
					"import",
                    null,
                    null,
                    treatment_params
				).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });

                this.$emit("launch_treatment", res.treatment.uid, this.data_action, data, this.idx_action, treatment_params);
            },
        },
        mounted: async function () {
            this.data_action = clone(this.action);

            if (this.data_action.treatment_params_arr)
            {
                for (var i = 0; i < this.data_action.treatment_params_arr.length; i++)
                {
                    this.params[this.data_action.treatment_params_arr[i].name] = this.data_action.treatment_params_arr[i];
                    if (this.data_action.treatment_params_arr[i].visible)
                        this.visible_column.push(this.data_action.treatment_params_arr[i].name);
                }
            }
            if (this.visible_column)
            {
                await this.$refs.actions.set(this.data_action.treatment_params_arr || [], this.data_action.treatment_params || {}, this.data_action.treatment_params_arr || []);
            }
        },
    }


</script>